"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchClusteredPickupPoints = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _tsUtils = require("@ori/ts-utils");
var _constants = require("../constants");
var _logger = require("../logger");
var _utils = require("../utils");
// istanbul ignore file -- api
const localLogger = _logger.mainLogger.createChild('fetchClusteredPickupPoints');
const clamp = (value, min, max)=>Math.min(Math.max(value, min), max);
const fetchClusteredPickupPoints = async (param)=>{
    let { headers, sessionId, customInstance, latitude, longitude, zoom } = param;
    try {
        const location = {
            latitude,
            longitude
        };
        // Calculate search area delta based on zoom level
        const delta = 0.00036 * 2 ** Math.max(_constants.MAP_MAX_ZOOM - zoom, 5);
        // Fetch clustered pickup points
        const clustersData = await (0, _globalApiClientReact.getShoppingSessionClusteredPickupPoints)(customInstance, sessionId, {
            north: clamp(location.latitude + delta, -90, 90),
            south: clamp(location.latitude - delta, -90, 90),
            east: clamp(location.longitude + delta * 2, -180, 180),
            west: clamp(location.longitude - delta * 2, -180, 180),
            zoom: _constants.MAP_MAX_ZOOM - zoom
        }, headers);
        return clustersData.data.collection.map(_utils.mapClusteredPickupPoint).filter(_tsUtils.isNonNullable);
    } catch (error) {
        localLogger.error(new Error('fetchGraphql', {
            cause: error
        }));
        throw error;
    }
};
exports.fetchClusteredPickupPoints = fetchClusteredPickupPoints;
